import { useEffect } from 'react'
import { useAuthStore } from '../store'

// ===========================================
// Provider de autenticación
// Verifica la sesión al cargar la app
// ===========================================

interface AuthProviderProps {
  children: React.ReactNode
}

export function AuthProvider({ children }: AuthProviderProps) {
  const checkSession = useAuthStore((state) => state.checkSession)

  useEffect(() => {
    checkSession()
  }, [checkSession])

  return <>{children}</>
}
